import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default ({ notifations }) => {
    return <div className="notification">
                <p className="noti-headline">Notification</p>
                <Row className="m-0">
                    {
                        notifations?.length && notifations.map((notifation, index) => {
                            return (
                                <Col className="tip-col" key={index} lg={12} md={12} sm={12} xs={12} style={{borderBottom: "1px solid rgb(206, 212, 218"}}>
                                    <div className="time-style">{notifation.date}</div>
                                    <div className="text-style">{notifation.message}</div>
                                </Col>
                            )
                        })
                    }
                </Row>
                <div className="noti-lnk"><a>Show All</a></div>
        </div>
}